<script>
import _ from "lodash";

export default {
    name: "VDataTableCustomHeaderFiltersAutocomplete",
    inheritAttrs: false,
    props: {
        header: {
            type: Object,
            required: true,
        },
        value: {
            type: Array,
        },
        items: {
            type: Array,
        },
        mapValuesFn: {
            type: Function,
            default: v => v,
        },
        itemTextWithHtml: {
            type: Boolean,
        },
    },
    data() {
        return {
            menuOpen: false, // Для отслеживания состояния меню
        };
    },
    computed: {
        internalValue: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit("input", val);
            },
        },
        itemsValues() {
            return _(this.items)
                .map(item => _.get(item, this.header.value))
                .filter(v => !!v || v === 0)
                .map(v => ({id: v, name: this.mapValuesFn(v)}))
                .uniq()
                .sort()
                .value();
        }
    },
    methods: {
        clearSelection() {
            this.$emit('input', []); // очищаем выбранные элементы
        },
        filterItems(items) {
            const filterValue = (this.value || []),
                headerValue = this.header.value;
            return filterValue.length ? _.filter(
                items,
                item => {
                    const value = _.get(item, headerValue);
                    return filterValue.includes(value);
                }) : items;
        },
    },
}
</script>

<template>
    <v-autocomplete
        v-bind="$attrs"
        v-on="$listeners"
        :label="header?.text"
        :items="itemsValues"
        item-value="id"
        item-text="name"
        multiple
        hide-details
        single-line
        class="mb-4"
        v-model="internalValue" 
        :clearable="false"
        v-bind:menu.sync="menuOpen"
        dense
        small-chips
        deletable-chips

    >
        <template v-slot:label>
            <div v-html="header?.filterLabel || header?.text"></div>
        </template>

        <template v-slot:selection="{ attrs, on, item, parent }">
            <v-chip
                v-bind="attrs"
                v-on="on"
                small
            >
                <span class="pr-2" v-html="item.name"></span>
                <v-icon small @click="parent.selectItem(item)">$delete</v-icon>
            </v-chip>
        </template>

        <!-- чтобы использовать v-html для вывода названия -->
        <template v-slot:item="{ item, attrs, on }">
            <v-list-item
                v-bind="attrs"
                v-on="on"
            >
                <v-list-item-action>
                    <v-checkbox :input-value="_.includes(internalValue, item.id)" color="primary" />
                </v-list-item-action>
                <v-list-item-content>
                    <div v-html="item.name"></div>
                </v-list-item-content>
            </v-list-item>
        </template>

        <!-- Слот append – справа от поля ввода -->
        <template v-slot:append>
            <!-- Счётчик скрытых элементов -->
            <div v-if="internalValue && internalValue.length > 2" class="v-autocomplete-counter">
                +{{ internalValue.length - 2 }}
            </div>
            <!-- Кнопка очистки, которая появляется при наличии выбранных элементов -->
            <v-icon
                small
                v-if="internalValue && internalValue.length > 0"
                @click.stop="clearSelection"
            >mdi-close</v-icon>
            <!-- Стрелочка, переворачивающаяся при открытии меню -->
            <v-icon small class="select-down">
                mdi-menu-down
            </v-icon>
        </template>

    </v-autocomplete>
</template>

<style scoped lang="scss">
/**
@TODO Посмотреть, что из стилей перестало быть актуальным
 */
.v-autocomplete.v-select.v-input--is-focused ::v-deep input {
    min-width: 0;
}

/* ::v-deep .v-select__selections {
    flex-wrap: nowrap;
    white-space: nowrap;
    gap: 5px;

    & > div {
        overflow: hidden;
        text-overflow: ellipsis;

        &:nth-child(n + 2) {
            display: none;
        }
    }
} */

.v-select ::v-deep {
    .v-input__append-inner { 
        display: flex;
        align-items: center;
        gap: 1px;
        padding: 0;
        margin: 0;
        align-self: center;
        .v-autocomplete-counter {
            margin-right: 3px;
        }
        .v-icon.mdi-close {
            font-size: 18px!important;
        }
        .select-down {
            transition: transform 0.3s ease;
            font-size: 20px!important;
            margin-left: -3px;
        }
    }
}
.v-select.v-select--is-menu-active ::v-deep .v-input__append-inner {
    .select-down {
        transform: rotate(180deg);
    }
}


::v-deep .v-select__selections {
    flex-wrap: nowrap;
    white-space: nowrap;
    gap: 5px;

    & > span {
        &:nth-child(n + 3) {
            display: none;
        }
    }

    .v-chip {
        margin-bottom: 2px;

        .v-chip__content {
            display: block;
            max-width: calc(100% - 16px);
            min-width: 30px;
            text-overflow: ellipsis;
            overflow: hidden;
            line-height: 24px;
            button {
                position: absolute;
                right: 8px;
                top: 3px;
            }
        }

    }
}
</style>